import { render, staticRenderFns } from "./RatgeberKategorie.vue?vue&type=template&id=b0bd6a30&scoped=true&"
import script from "./RatgeberKategorie.vue?vue&type=script&lang=js&"
export * from "./RatgeberKategorie.vue?vue&type=script&lang=js&"
import style0 from "./RatgeberKategorie.vue?vue&type=style&index=0&id=b0bd6a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bd6a30",
  null
  
)

export default component.exports